import React, { useState, useEffect } from "react";
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useToast,
  Box,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
// import * as yup from "yup";
// import { yupResolver } from "@hookform/resolvers/yup";
import useAxios from "axios-hooks";
import { API_ROUTES } from "utils/constant";
import InputController from "components/Form/InputController";
import { ROOT_API } from "utils/constant";

const defaultValues = {
  recipientEmail: "",
  subject: "",
  body: "",
};

const SendEmailTestModal = ({ isOpen, smtpId, smtpBackUpId, onClose }) => {
  const cancelRef = React.useRef();
  const toast = useToast();

  const [emailResult, setEmailResult] = useState(null);

  const [{ loading: createLoading }, sendEmailApi] = useAxios(
    {
      url: ROOT_API + API_ROUTES.SEND_EMAIL_CAMPAIGN,
      method: "post",
    },
    { manual: true }
  );

  // const schema = yup.object().shape({
  //   recipientEmail: yup.string().required("Vui lòng nhập email"),
  //   subject: yup.string().nullable().required("Vui lòng nhập title"),
  //   body: yup.string().nullable().required("Vui lòng nhập body"),
  // });
  const { control, handleSubmit, reset } = useForm({
    // resolver: yupResolver(schema),
    defaultValues,
  });

  useEffect(
    () => () => {
      reset();
      setEmailResult(null);
    },
    []
  );

  const onSubmit = (values) => {
    toast.closeAll();

    sendEmailApi({
      data: {
        ...values,
        smtpId: smtpId,
        ...(smtpBackUpId && { smtpBackUpId }),
      },
    })
      .then((res) => {
        setEmailResult(res?.data);
        reset();
      })
      .catch((error) => {
        console.error(error);
        setEmailResult(error.response.data.data);
      });
  };

  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={() => {
          reset();
          onClose?.();
          setEmailResult(null);
        }}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>Email Test</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            {!emailResult && (
              <form>
                <InputController
                  control={control}
                  name="recipientEmail"
                  label="Email"
                />
                <InputController
                  styleContainer={{ pt: "4" }}
                  control={control}
                  name="subject"
                  label="Tiêu đề"
                />
                <InputController
                  styleContainer={{ pt: "4" }}
                  control={control}
                  name="body"
                  label="Nội dung"
                />
              </form>
            )}
            {emailResult && <Box pt={4}>{JSON.stringify(emailResult)}</Box>}
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={() => {
                reset();
                onClose?.();
                setEmailResult(null);
              }}
            >
              Cancel
            </Button>
            {!emailResult && (
              <Button
                colorScheme="blue"
                ml={3}
                isLoading={createLoading}
                onClick={handleSubmit(onSubmit)}
              >
                Send
              </Button>
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default SendEmailTestModal;
